import type { BoardDef } from '@archon3d/core';

interface Props {
  /** Boards that ship with the game. */
  bundled: BoardDef[];
  /** Boards drawn in the editor and saved in this browser. */
  saved: BoardDef[];
  chosen: string;
  onChoose: (id: string) => void;
  onEdit: () => void;
  onBack: () => void;
}

/** The boards to play on: the bundled ones, then those saved from the editor. */
export function BoardPicker({ bundled, saved, chosen, onChoose, onEdit, onBack }: Props) {
  return (
    <>
      <h2 className="menu-heading">Select game</h2>
      <BoardList boards={bundled} chosen={chosen} onChoose={onChoose} />
      {saved.length > 0 && (
        <>
          <p className="board-section">Saved in this browser</p>
          <BoardList boards={saved} chosen={chosen} onChoose={onChoose} />
        </>
      )}
      <p className="hint">
        {saved.length === 0
          ? 'Boards drawn in the editor and saved will appear here.'
          : 'Saved boards come from the editor and stay in this browser.'}
      </p>
      <div className="menu-actions">
        <button onClick={onEdit}>Open editor</button>
        <button onClick={onBack}>Back</button>
      </div>
    </>
  );
}

function BoardList({
  boards,
  chosen,
  onChoose,
}: {
  boards: BoardDef[];
  chosen: string;
  onChoose: (id: string) => void;
}) {
  return (
    <ul className="board-list">
      {boards.map((board) => (
        <li key={board.id} className={board.id === chosen ? 'active' : ''}>
          <button
            className="board-card"
            onClick={() => onChoose(board.id)}
            data-testid={`board-${board.id}`}
          >
            <strong>{board.name}</strong>
            <span className="muted">
              {board.grid === 'hex' ? 'hexes' : 'squares'} · {board.width}×{board.height} ·{' '}
              {board.factions.length} sides · {board.powerPoints.length} power points
            </span>
            {board.description && <span className="muted small">{board.description}</span>}
          </button>
        </li>
      ))}
    </ul>
  );
}
